import { createAsyncThunk } from "@reduxjs/toolkit";
import { URL_USER } from "../../config/connString";
import useAxios from "../../utils/useAxios";
const addUserByRole = createAsyncThunk(
  "user/add-user-by-role",
  async (data) => {
    try {
      const api = useAxios();
      const response = await api.post(
        URL_USER + "/" + data.userId + "/roles" + data.role,
        {
          roleName: data.roleName,
        }
      );
      return response.data;
    } catch (error) {
      return error;
    }
  }
);

export { addUserByRole };
